import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createDevice = (data) => ({
  type: ActionTypes.DEVICE_CREATE,
  payload: {
    data,
  },
});

export const updateDevice = (id, data) => ({
  type: ActionTypes.DEVICE_UPDATE,
  payload: {
    id,
    data,
  },
});

export const updateDeviceCommon = (id, data) => ({
  type: ActionTypes.DEVICE_COMMON_UPDATE,
  payload: {
    id,
    data,
  },
});

export const hideDevice = (id) => ({
  type: ActionTypes.DEVICE_HIDE,
  payload: {
    id,
  },
});

export const deleteDevice = (id) => ({
  type: ActionTypes.DEVICE_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createDeviceRequested = (data) => ({
  type: ActionTypes.DEVICE_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createDeviceSucceeded = (
  device,
  deviceMemberships,
  deviceLabels,
  alarms,
  attachments,
) => ({
  type: ActionTypes.DEVICE_CREATE_SUCCEEDED,
  payload: {
    device,
    deviceMemberships,
    deviceLabels,
    alarms,
    attachments,
  },
});

export const createDeviceFailed = (localId, error) => ({
  type: ActionTypes.DEVICE_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createDeviceReceived = (
  device,
  deviceMemberships,
  deviceLabels,
  alarms,
  attachments,
) => ({
  type: ActionTypes.DEVICE_CREATE_RECEIVED,
  payload: {
    device,
    deviceMemberships,
    deviceLabels,
    alarms,
    attachments,
  },
});

export const fetchDeviceRequested = (id) => ({
  type: ActionTypes.DEVICE_FETCH_REQUESTED,
  payload: {
    id,
  },
});

export const fetchDeviceSucceeded = (device) => ({
  type: ActionTypes.DEVICE_FETCH_SUCCEEDED,
  payload: {
    device,
  },
});

export const fetchDeviceFailed = (id, error) => ({
  type: ActionTypes.DEVICE_FETCH_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateDeviceRequested = (id, data) => ({
  type: ActionTypes.DEVICE_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateDeviceSucceeded = (device) => ({
  type: ActionTypes.DEVICE_UPDATE_SUCCEEDED,
  payload: {
    device,
  },
});

export const updateDeviceFailed = (id, error) => ({
  type: ActionTypes.DEVICE_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateDeviceReceived = (device) => ({
  type: ActionTypes.DEVICE_UPDATE_RECEIVED,
  payload: {
    device,
  },
});

export const updateDeviceCommonRequested = (id, data) => ({
  type: ActionTypes.DEVICE_COMMON_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateDeviceCommonSucceeded = (device) => ({
  type: ActionTypes.DEVICE_COMMON_UPDATE_SUCCEEDED,
  payload: {
    device,
  },
});

export const updateDeviceCommonFailed = (id, error) => ({
  type: ActionTypes.DEVICE_COMMON_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateDeviceCommonReceived = (device) => ({
  type: ActionTypes.DEVICE_COMMON_UPDATE_RECEIVED,
  payload: {
    device,
  },
});

export const hideDeviceRequested = (id) => ({
  type: ActionTypes.DEVICE_HIDE_REQUESTED,
  payload: {
    id,
  },
});

export const hideDeviceSucceeded = (device) => ({
  type: ActionTypes.DEVICE_HIDE_SUCCEEDED,
  payload: {
    device,
  },
});

export const hideDeviceFailed = (id, error) => ({
  type: ActionTypes.DEVICE_HIDE_FAILED,
  payload: {
    id,
    error,
  },
});

export const hideDeviceReceived = (device) => ({
  type: ActionTypes.DEVICE_HIDE_RECEIVED,
  payload: {
    device,
  },
});

export const deleteDeviceRequested = (id) => ({
  type: ActionTypes.DEVICE_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteDeviceSucceeded = (device) => ({
  type: ActionTypes.DEVICE_DELETE_SUCCEEDED,
  payload: {
    device,
  },
});

export const deleteDeviceFailed = (id, error) => ({
  type: ActionTypes.DEVICE_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteDeviceReceived = (device) => ({
  type: ActionTypes.DEVICE_DELETE_RECEIVED,
  payload: {
    device,
  },
});
